/**
 * Where this learner is in the guided first visit, kept in this browser per learner (Sol realbuild1 R3: badges are
 * the durable record; UI-only guidance lives here). Losing it is harmless: initialStep() restarts from the first
 * step whose badge is not held, and repeating guidance never pays anything twice.
 *
 *   {step: <journey step id>, replay: boolean}  - replay marks a tour started from "Replay tour" (Sol player-tour Q1 D)
 */
const key = userId => `ql-first-visit-v1:${userId}`;

const store = () => {
  try {
    return typeof window !== 'undefined' && window.localStorage ? window.localStorage : null;
  } catch (_) {
    return null;
  }
};

export function readProgress(userId, storage = store()) {
  if (!userId || !storage) return null;
  try {
    const value = JSON.parse(storage.getItem(key(userId)) || 'null');
    return value && typeof value.step === 'string' ? {step: value.step, replay: !!value.replay} : null;
  } catch (_) {
    return null;
  }
}

export function writeProgress(userId, progress, storage = store()) {
  if (!userId || !storage) return;
  try {
    storage.setItem(key(userId), JSON.stringify({step: progress.step, replay: !!progress.replay}));
  } catch (_) {
    // Private windows and full storage: the tour still runs, it just restarts from the badges next time.
  }
}

/** "Replay tour": start again from the first step, whatever the learner's account age. */
export function startReplay(userId, storage = store()) {
  writeProgress(userId, {step: 'walk_w', replay: true}, storage);
}
